import { StarsExtraIcon } from '@braskai/icons';
import { useLocalStorage } from 'react-use';

import { PATHS } from '@/shared/constants/routes/paths';
import { IS_WHITE_LABEL } from '@/shared/environments';
import { useInterfaceLanguage } from '@/shared/i18n';
import { PromoBanner } from '@/shared/ui/PromoBanner';

const LS_SHOW_TRIAL_SIDEBAR_BANNER = 'showTrialSidebarBanner';

export const TrialSidebarBanner = () => {
  const { t } = useInterfaceLanguage();
  const [show, setShowBanner] = useLocalStorage(LS_SHOW_TRIAL_SIDEBAR_BANNER, true);

  const handleClose = () => {
    setShowBanner(false);
  };

  const isShowBanner = show && !IS_WHITE_LABEL;

  if (!isShowBanner) {
    return null;
  }

  return (
    <PromoBanner
      title={t('trial.sidebarBanner.title')}
      link={{
        children: t('trial.sidebarBanner.cta'),
        state: { pricingEntryPoint: 'sidebar_trial_banner' },
        to: `/${PATHS.pricing}`,
      }}
      icon={<StarsExtraIcon />}
      variant="primary"
      onClose={handleClose}
    />
  );
};
